// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HdW8r","image":"styles_image__PHXbw","hints":"styles_hints__Swzor"};